var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 0H.75A.75.75 0 0 0 0 .75v16.5c0 .414.336.75.75.75h8.813v-6.75h-2.25V8.437h2.25v-2.25c0-2.324 1.472-3.468 3.545-3.468.994 0 1.848.074 2.096.106v2.43l-1.438.001c-1.128 0-1.391.536-1.391 1.322v1.86h2.813l-.563 2.812h-2.25L12.42 18h4.83a.75.75 0 0 0 .75-.75V.75a.75.75 0 0 0-.75-.75"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.672a3abb.svg";
export { ForwardRef as ReactComponent };